import { useEffect, useRef, useState } from "react";
import { generateInstagramStory } from "../utils/instagramStoryGenerator";
import { shareToNative } from "../utils/nativeShare";
import uflixLogo from "../assets/logowhite.png";

export default function ShareModal({ title, tvData, poster, onClose }) {
  const pageUrl = window.location.href;
  const canvasRef = useRef(null);
  const [storyReady, setStoryReady] = useState(false);


  /* =========================
     Resolve data
  ========================== */
  const resolvedTitle =
    title ||
    tvData?.name ||
    tvData?.title ||
    "";

  const resolvedPoster =
    poster ||
    tvData?.poster_path ||
    null;

  const shareText = resolvedTitle
    ? `Watch ${resolvedTitle} on uFlix!`
    : "Watch on uFlix!";

  /* =========================
     Pre-generate canvas (IMPORTANT)
     Runs when modal opens
  ========================== */
  useEffect(() => {
    let mounted = true;

    generateInstagramStory({
      title: resolvedTitle,
      posterUrl: resolvedPoster
        ? `https://image.tmdb.org/t/p/w500${resolvedPoster}`
        : null,
      logoUrl: uflixLogo,
    }).then((canvas) => {
      if (mounted) {
        canvasRef.current = canvas;
        setStoryReady(true);
      }
    });

    return () => {
      mounted = false;
    };
  }, [resolvedTitle, resolvedPoster]);

  /* =========================
     Share handlers
  ========================== */
  const shareX = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        shareText
      )}&url=${encodeURIComponent(pageUrl)}`,
      "_blank"
    );
  };

  const shareWhatsapp = () => {
    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        `${shareText} ${pageUrl}`
      )}`,
      "_blank"
    );
  };

  // ✅ iOS SAFE — NO ASYNC
  const shareInstagram = () => {
    if (!storyReady || !canvasRef.current) return;

    shareToNative({
      canvas: canvasRef.current,
      text: shareText,
    });
  };

  /* =========================
     UI
  ========================== */
  return (
    <div className="share-overlay">
      <div className="share-modal">
        <h3>Share</h3>

        <div className="share-options">
          <button onClick={shareX}>X</button>
          <button onClick={shareInstagram} disabled={!storyReady}>
            {storyReady ? "IG" : "Preparing…"}
          </button>
          <button onClick={shareWhatsapp}>WA</button>
        </div>

        <button className="close-btn" onClick={onClose}>✕</button>
      </div>
    </div>
  );
}
